var classes = {"cartBadgeRoot":"UEOHe","cartLabelWrapper":"afrHu","cartLabelWrapperLong":"GBKf9","cartLabel":"we-zf"};

export { classes as default };
